import { FC } from 'react';

const TOOLTIP_STYLE: React.CSSProperties = {
  position: 'absolute',
  display: 'none',
  background: 'rgba(0, 0, 0, 0.8)',
  color: 'white',
  padding: '5px',
  borderRadius: '3px',
  pointerEvents: 'none',
  zIndex: 10,
  fontFamily: 'Arial, sans-serif',
  fontSize: '12px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
};

type TooltipProps = {
  tooltipRef: React.MutableRefObject<HTMLDivElement | null>;
};

export const Tooltip: FC<TooltipProps> = ({ tooltipRef }) => {
  return <div ref={tooltipRef} style={TOOLTIP_STYLE}></div>;
};
